import actionsEn from "./actions/en.json";
import dashboardEn from "./dashboard/en.json";
import exclusiveAccessEn from "./exclusiveAccess/en.json";
import generalEn from "./general/en.json";
import loyaltyManagementEn from "./loyaltyManagement/en.json";
import memberProfileEn from "./memberProfile/en.json";
import securitySettingsEn from "./securitySettings/en.json";
import tiersEn from "./tiers/en.json";
import voucherEn from "./voucher/en.json";

import actionsDe from "./actions/de.json";
import dashboardDe from "./dashboard/de.json";
import exclusiveAccessDe from "./exclusiveAccess/de.json";
import generalDe from "./general/de.json";
import loyaltyManagementDe from "./loyaltyManagement/de.json";
import memberProfileDe from "./memberProfile/de.json";
import securitySettingsDe from "./securitySettings/de.json";
import tiersDe from "./tiers/de.json";
import voucherDe from "./voucher/de.json";

import { actionsDeLegacy } from "./actions/de.legacy.js";
import { exclusiveAccessDeLegacy } from "./exclusiveAccess/de.legacy.js";
import { generalDeLegacy } from "./general/de.legacy.js";
import { memberProfileDeLegacy } from "./memberProfile/de.legacy.js";
import { securitySettingsDeLegacy } from "./securitySettings/de.legacy.js";
import { tiersDeLegacy } from "./tiers/de.legacy.js";
import { voucherDeLegacy } from "./voucher/de.legacy.js";

import actionsEs from "./actions/es.json";
import dashboardEs from "./dashboard/es.json";
import exclusiveAccessEs from "./exclusiveAccess/es.json";
import generalEs from "./general/es.json";
import loyaltyManagementEs from "./loyaltyManagement/es.json";
import memberProfileEs from "./memberProfile/es.json";
import securitySettingsEs from "./securitySettings/es.json";
import tiersEs from "./tiers/es.json";
import voucherEs from "./voucher/es.json";

import actionsCs from "./actions/cs.json";
import dashboardCs from "./dashboard/cs.json";
import exclusiveAccessCs from "./exclusiveAccess/cs.json";
import generalCs from "./general/cs.json";
import loyaltyManagementCs from "./loyaltyManagement/cs.json";
import memberProfileCs from "./memberProfile/cs.json";
import securitySettingsCs from "./securitySettings/cs.json";
import tiersCs from "./tiers/cs.json";
import voucherCs from "./voucher/cs.json";

import actionsFr from "./actions/fr.json";
import dashboardFr from "./dashboard/fr.json";
import exclusiveAccessFr from "./exclusiveAccess/fr.json";
import generalFr from "./general/fr.json";
import loyaltyManagementFr from "./loyaltyManagement/fr.json";
import memberProfileFr from "./memberProfile/fr.json";
import securitySettingsFr from "./securitySettings/fr.json";
import tiersFr from "./tiers/fr.json";
import voucherFr from "./voucher/fr.json";

import actionsJa from "./actions/ja.json";
import dashboardJa from "./dashboard/ja.json";
import exclusiveAccessJa from "./exclusiveAccess/ja.json";
import generalJa from "./general/ja.json";
import loyaltyManagementJa from "./loyaltyManagement/ja.json";
import memberProfileJa from "./memberProfile/ja.json";
import securitySettingsJa from "./securitySettings/ja.json";
import tiersJa from "./tiers/ja.json";
import voucherJa from "./voucher/ja.json";

import actionsKo from "./actions/ko.json";
import dashboardKo from "./dashboard/ko.json";
import exclusiveAccessKo from "./exclusiveAccess/ko.json";
import generalKo from "./general/ko.json";
import loyaltyManagementKo from "./loyaltyManagement/ko.json";
import memberProfileKo from "./memberProfile/ko.json";
import securitySettingsKo from "./securitySettings/ko.json";
import tiersKo from "./tiers/ko.json";
import voucherKo from "./voucher/ko.json";

import actionsPl from "./actions/pl.json";
import dashboardPl from "./dashboard/pl.json";
import exclusiveAccessPl from "./exclusiveAccess/pl.json";
import generalPl from "./general/pl.json";
import loyaltyManagementPl from "./loyaltyManagement/pl.json";
import memberProfilePl from "./memberProfile/pl.json";
import securitySettingsPl from "./securitySettings/pl.json";
import tiersPl from "./tiers/pl.json";
import voucherPl from "./voucher/pl.json";

import actionsPt from "./actions/pt.json";
import dashboardPt from "./dashboard/pt.json";
import exclusiveAccessPt from "./exclusiveAccess/pt.json";
import generalPt from "./general/pt.json";
import loyaltyManagementPt from "./loyaltyManagement/pt.json";
import memberProfilePt from "./memberProfile/pt.json";
import securitySettingsPt from "./securitySettings/pt.json";
import tiersPt from "./tiers/pt.json";
import voucherPt from "./voucher/pt.json";

import actionsRu from "./actions/ru.json";
import dashboardRu from "./dashboard/ru.json";
import exclusiveAccessRu from "./exclusiveAccess/ru.json";
import generalRu from "./general/ru.json";
import loyaltyManagementRu from "./loyaltyManagement/ru.json";
import memberProfileRu from "./memberProfile/ru.json";
import securitySettingsRu from "./securitySettings/ru.json";
import tiersRu from "./tiers/ru.json";
import voucherRu from "./voucher/ru.json";

import actionsTr from "./actions/tr.json";
import dashboardTr from "./dashboard/tr.json";
import exclusiveAccessTr from "./exclusiveAccess/tr.json";
import generalTr from "./general/tr.json";
import loyaltyManagementTr from "./loyaltyManagement/tr.json";
import memberProfileTr from "./memberProfile/tr.json";
import securitySettingsTr from "./securitySettings/tr.json";
import tiersTr from "./tiers/tr.json";
import voucherTr from "./voucher/tr.json";

import actionsZhCn from "./actions/zh_CN.json";
import dashboardZhCn from "./dashboard/zh_CN.json";
import exclusiveAccessZhCn from "./exclusiveAccess/zh_CN.json";
import generalZhCn from "./general/zh_CN.json";
import loyaltyManagementZhCn from "./loyaltyManagement/zh_CN.json";
import memberProfileZhCn from "./memberProfile/zh_CN.json";
import securitySettingsZhCn from "./securitySettings/zh_CN.json";
import tiersZhCn from "./tiers/zh_CN.json";
import voucherZhCn from "./voucher/zh_CN.json";

import actionsZhTw from "./actions/zh_TW.json";
import dashboardZhTw from "./dashboard/zh_TW.json";
import exclusiveAccessZhTw from "./exclusiveAccess/zh_TW.json";
import generalZhTw from "./general/zh_TW.json";
import loyaltyManagementZhTw from "./loyaltyManagement/zh_TW.json";
import memberProfileZhTw from "./memberProfile/zh_TW.json";
import securitySettingsZhTw from "./securitySettings/zh_TW.json";
import tiersZhTw from "./tiers/zh_TW.json";
import voucherZhTw from "./voucher/zh_TW.json";

export const en = {
  ...actionsEn,
  ...dashboardEn,
  ...exclusiveAccessEn,
  ...generalEn,
  ...loyaltyManagementEn,
  ...memberProfileEn,
  ...securitySettingsEn,
  ...tiersEn,
  ...voucherEn
};

export const de = {
  ...actionsDeLegacy,
  ...actionsDe,
  ...dashboardDe,
  ...exclusiveAccessDeLegacy,
  ...exclusiveAccessDe,
  ...generalDeLegacy,
  ...generalDe,
  ...loyaltyManagementDe,
  ...memberProfileDeLegacy,
  ...memberProfileDe,
  ...securitySettingsDeLegacy,
  ...securitySettingsDe,
  ...tiersDeLegacy,
  ...tiersDe,
  ...voucherDeLegacy,
  ...voucherDe
};

export const es = {
  ...actionsEs,
  ...dashboardEs,
  ...exclusiveAccessEs,
  ...generalEs,
  ...loyaltyManagementEs,
  ...memberProfileEs,
  ...securitySettingsEs,
  ...tiersEs,
  ...voucherEs
};

export const cs = {
  ...actionsCs,
  ...dashboardCs,
  ...exclusiveAccessCs,
  ...generalCs,
  ...loyaltyManagementCs,
  ...memberProfileCs,
  ...securitySettingsCs,
  ...tiersCs,
  ...voucherCs
};

export const fr = {
  ...actionsFr,
  ...dashboardFr,
  ...exclusiveAccessFr,
  ...generalFr,
  ...loyaltyManagementFr,
  ...memberProfileFr,
  ...securitySettingsFr,
  ...tiersFr,
  ...voucherFr
};

export const ja = {
  ...actionsJa,
  ...dashboardJa,
  ...exclusiveAccessJa,
  ...generalJa,
  ...loyaltyManagementJa,
  ...memberProfileJa,
  ...securitySettingsJa,
  ...tiersJa,
  ...voucherJa
};

export const ko = {
  ...actionsKo,
  ...dashboardKo,
  ...exclusiveAccessKo,
  ...generalKo,
  ...loyaltyManagementKo,
  ...memberProfileKo,
  ...securitySettingsKo,
  ...tiersKo,
  ...voucherKo
};

export const pl = {
  ...actionsPl,
  ...dashboardPl,
  ...exclusiveAccessPl,
  ...generalPl,
  ...loyaltyManagementPl,
  ...memberProfilePl,
  ...securitySettingsPl,
  ...tiersPl,
  ...voucherPl
};

export const pt = {
  ...actionsPt,
  ...dashboardPt,
  ...exclusiveAccessPt,
  ...generalPt,
  ...loyaltyManagementPt,
  ...memberProfilePt,
  ...securitySettingsPt,
  ...tiersPt,
  ...voucherPt
};

export const ru = {
  ...actionsRu,
  ...dashboardRu,
  ...exclusiveAccessRu,
  ...generalRu,
  ...loyaltyManagementRu,
  ...memberProfileRu,
  ...securitySettingsRu,
  ...tiersRu,
  ...voucherRu
};

export const tr = {
  ...actionsTr,
  ...dashboardTr,
  ...exclusiveAccessTr,
  ...generalTr,
  ...loyaltyManagementTr,
  ...memberProfileTr,
  ...securitySettingsTr,
  ...tiersTr,
  ...voucherTr
};

export const zh_tw = {
  ...actionsZhTw,
  ...dashboardZhTw,
  ...exclusiveAccessZhTw,
  ...generalZhTw,
  ...loyaltyManagementZhTw,
  ...memberProfileZhTw,
  ...securitySettingsZhTw,
  ...tiersZhTw,
  ...voucherZhTw
};

export const zh_cn = {
  ...actionsZhCn,
  ...dashboardZhCn,
  ...exclusiveAccessZhCn,
  ...generalZhCn,
  ...loyaltyManagementZhCn,
  ...memberProfileZhCn,
  ...securitySettingsZhCn,
  ...tiersZhCn,
  ...voucherZhCn
};
